module.exports = __webpack_public_path__ + "static/media/montell-workshop.7a2bce85.png";